<template>
    <div :class="css.container" ref="container" v-on="ons.drag" v-show="visible">
        <div ref="controls">
            <ui-icon :class="css.control" name="close2" @click="visible = false" />
        </div>

        <div :class="css.modules">
            <div :class="css.module" v-if="view?.data?.name">
                <div :class="css.name">{{ useColon($t("AA", 2)) }}</div>
                <div :class="css.value">{{ view.data.name }}</div>
            </div>

            <div :class="css.module">
                <div :class="css.name">{{ mode == "codon" ? useColon($t("AALocation")) : useColon($t("GenePosition")) }}</div>
                <div :class="css.value">
                    {{ view?.data?.site || "--" }}
                    <span v-if="!view?.data?.codon" :class="css.button" @mousedown="emits('codon')">{{ $t("CodonChart") }}</span>
                </div>
            </div>

            <div :class="css.module">
                <div :class="css.name">{{ useColon($t("CDSPosition")) }}</div>
                <div :class="css.value">{{ view?.data?.sites?.cds || "--" }}</div>
            </div>

            <div :class="css.module">
                <div :class="css.name">{{ useColon($t("GenomicLocation")) }}</div>
                <div :class="css.value">{{ view?.data?.sites?.genome || "--" }}</div>
            </div>

            <div :class="css.module">
                <div :class="css.name">{{ useColon($t("Region")) }}</div>
                <div :class="css.value">{{ view?.data?.area || "--" }}</div>
            </div>

            <div :class="css.module" v-if="view?.data?.codon">
                <div :class="css.name">{{ useColon($t("Codon")) }}</div>
                <div :class="css.value">
                    {{ view.data.codon }}
                    <span :class="css.button" @click="emits('codon')">{{ $t("CodonChart") }}</span>
                </div>
            </div>

            <div :class="css.module" v-if="view?.mutations?.count">
                <div :class="css.name">{{ useColon($t("MutationCount")) }}</div>
                <div :class="css.value">{{ view.mutations.count }}</div>
            </div>

            <template v-if="view?.mutations">
                <template v-for="value in options.mutations">
                    <div :class="css.module" v-if="view.mutations.data?.[value.value]">
                        <div
                            :class="css.name"
                            :style="{
                                color: `var(--ui-${value.value.replace(/\s+/g, '-').toLocaleLowerCase()}-color)`,
                            }">
                            {{ value.name }}:
                        </div>
                        <div :class="css.value">{{ view.mutations.data[value.value].length }}</div>
                    </div>
                </template>
            </template>
        </div>

        <div :class="css.more" v-if="view?.mutations">
            <div :class="css_normalize.assets" @click="emits('mutations')">{{ $t("RecordedMutationsAIPrediction") }}</div>
        </div>

        <template v-if="!view?.mutations && specie == 9606">
            <div :class="css.extra" v-if="view?.data?.codons?.find((value: any) => value.area != view?.data?.area)">
                <div :class="css.descript">{{ $t("MutationPredictorDesc2") }}</div>
            </div>
            <div :class="css.extra" v-else>
                <div :class="css.descript">{{ $t("MutationPredictorDesc") }}</div>
                <div :class="css.entrances">
                    <div :class="[css.entrance, css_normalize.assets]" @click="emits('next', 'Pathogenicity-Predictor')">
                        <span>Patho Predictor</span>
                        <ui-icon name="arrow" />
                    </div>
                    <div :class="[css.entrance, css_normalize.assets]" @click="emits('next', 'RNA-Splicer')">
                        <span>RNA Splicer</span>
                        <ui-icon name="arrow" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 组件属性
import { ModulePropsOption, ModuleEmits } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";
//* 组件属性注册
const define = defineProps(ModulePropsOption);
const emits = defineEmits(ModuleEmits);

//* 组合函数
const { refs, nodes, methods, ons, options } = useComposable(define, emits);
const { open, close } = methods;
const { container, controls } = nodes;
const { visible, view } = refs;

//* 组件属性导出
defineExpose({ open, view, close });
</script>
